import React from "react";
import ReactEcharts from "echarts-for-react";
import { Box } from "@mui/system";
import { normalizeValueForColor, showData, normalizeMostActiveModuleData } from "../utils";
import ChartWithShowAll from "./ChartWithShowAll";

export default function MostVisitedDashboardsChart({ data }) {
    const dashboardRegistry = window.dashboardRegistry;

    // Merge TRX variants into their base dashboard path before sorting/rendering
    const normalizedData = normalizeMostActiveModuleData(data);

    const sortedData = normalizedData
        .filter((item) => item.module !== "/dashboard")
        .sort((a, b) => b.view_count - a.view_count);

    const [showAll, setShowAll] = React.useState(false);
    const displayData = showData(showAll, sortedData);

    const xAxisData = displayData.map((item) => item.module).reverse();
    const seriesData = displayData
        .map((item) => ({
            value: item.view_count,
            itemStyle: {
                color:
                    displayData?.length <= 3
                        ? "#000099"
                        : `hsl(240, 100%, ${normalizeValueForColor(item.view_count, displayData)}%)`,
            },
        }))
        .reverse();

    const option = {
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            formatter: (params) => {
                const viewCount = seriesData[params[0].dataIndex].value;
                return `Visits: <strong>${viewCount}</strong>`;
            },
        },
        grid: { containLabel: true, top: "3%", left: "5%", right: "3%", bottom: "3%" },
        xAxis: { type: "value" },
        yAxis: {
            type: "category",
            data: xAxisData,
            axisLabel: {
                formatter: (value) => {
                    const [dashboardPath, dashboardDetail] = value.split(":");
                    if (dashboardRegistry[dashboardPath]) {
                        return (
                            dashboardRegistry[dashboardPath].name +
                            (dashboardDetail ? ` - ${dashboardDetail}` : "")
                        );
                    }
                    return value;
                },
            },
        },
        series: [{ type: "bar", data: seriesData, barMaxWidth: 30 }],
    };

    return (
        <ChartWithShowAll length={sortedData?.length} showAll={showAll} setShowAll={setShowAll}>
            <Box sx={{ height: "25rem", overflow: "auto" }}>
                <ReactEcharts
                    option={option}
                    notMerge={true}
                    lazyUpdate={true}
                    style={{ width: "100%", height: !showAll ? "25rem" : `${Math.max(25, sortedData.length * 2)}rem` }}
                />
            </Box>
        </ChartWithShowAll>
    );
}

